import { imageDiscountCollection } from "@/firebase";

const state = {
  imageDiscount: {}
};

const getters = {};

const actions = {
  getImageDiscount({ commit }, payload) {
    imageDiscountCollection
      .where("client", "==", payload)
      .orderBy("quantity", "asc")
      //.limit(10)
      .get()
      .then(querySnapshot => {
        let tempData = [];
        querySnapshot.forEach(doc => {
          tempData.push(Object.assign(doc.data(), { id: doc.id }));
        });
        commit("getImageDiscount", tempData);
      });
  },
  addImageDiscount({ commit }, payload) {
    imageDiscountCollection.add(payload).then(docRef => {
      commit("addImageDiscount", Object.assign(payload, { id: docRef.id }));
    });
  },
  removeImageDiscount({ commit }, payload) {
    imageDiscountCollection
      .doc(payload)
      .delete()
      .then(() => {
        commit("removeImageDiscount", payload);
      });
  },
  editImageDiscount({ commit }, payload) {
    imageDiscountCollection
      .doc(payload.id)
      .set(payload)
      .then(() => {
        commit("editImageDiscount", payload);
      });
  }
};

const mutations = {
  getImageDiscount(state, payload) {
    state.imageDiscount = payload;
  },
  addImageDiscount(state, payload) {
    state.imageDiscount.push(payload);
  },
  removeImageDiscount(state, payload) {
    const index = state.imageDiscount.findIndex(item => item.id == payload);
    state.imageDiscount.splice(index, 1);
  },
  editImageDiscount(state, payload) {
    const index = state.imageDiscount.findIndex(item => item.id == payload.id);
    state.imageDiscount.splice(index, 1, payload);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
